export const EmployeeActionBarEN = {
    "employeeActionBar": {
        "tab": {
            "detail": "Resume",
            "jobDetail": "Job Details",
            "contract": "Contract",
            "salary": "Salary & Allowances",
            "admission": "Onboarding",
            "insurance": "Insurance",
            "decision": "Decision",
            "fileAttach": "Attachments",
            "asset": "Assets"
        },
        "item": {
            "status": "Status",
            "salary": "Salary",
            "job": "Job",
            "education": "Education",
            "family": "Family",
            "auditing": "Activity History",
            "update": "Update",
            "communist": "Party Member History",
            "experience": "Work Experience",
            "receptionFile": "Onboarding Information",
            "concurrently": "Concurrent Position",
            "insurance": "Insurance Information",
            "insuranceRate": "Insurance Rate",
            "fine": "Internal Discipline",
            "rewardWelfare": "Rewards / Benefits",
            "account": "Create Account",
            "back": "Go Back"
        }
    }
}